import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestCookieGroupOrderPut = {
    path: "/cookie-groups/order",
    method: RouteHttpVerb.PUT
};
